import React from 'react';
export const ProductIntroSection = () => {
  const bullets = ['Sistema completo por área técnica', 'Ejercicios prácticos resueltos', '50 queries SQL + 50 prompts IA listos', 'Guía completa de CV, GitHub y entrevistas', 'Adaptado a UTN, UBA, UNLP, UADE y más'];
  return <section className="bg-megapack-bg py-10 md:py-16 px-4 md:px-6" data-id="element-171">
      <div className="max-w-5xl mx-auto text-center w-[92%] md:w-full" data-id="element-172">
        <div className="inline-block bg-megapack-cyan text-megapack-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-173">
          💻 El Sistema IT Más Completo para Estudiantes Argentinos
        </div>

        <h2 className="text-4xl sm:text-6xl md:text-7xl font-display font-bold mb-2" data-id="element-174">
          MEGA PACK™
        </h2>
        <h3 className="text-[22px] sm:text-2xl md:text-3xl font-display font-bold text-megapack-cyan mb-6 md:mb-8 uppercase tracking-widest" data-id="element-175">
          INFORMÁTICA 2026
        </h3>

        <p className="text-megapack-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-176">
          6 Módulos + 3 Bonos — Todas las materias — Todo resuelto.
        </p>

        <div className="bg-megapack-card border border-megapack-cyan/10 p-6 md:p-12 rounded-3xl mb-10 md:mb-16" data-id="element-177">
          <p className="text-megapack-gray text-[15px] md:text-lg mb-8 md:mb-12 leading-relaxed" data-id="element-178">
            <span className="text-white font-bold" data-id="element-179">+180 páginas</span> · 6
            módulos completos · 3 bonos · Algoritmos · POO · Base de Datos · IA
            · Técnicas de Estudio · Primer Trabajo IT · 50 Prompts listos ·
            Cheat Sheets · Planificador. <br data-id="element-180" />
            <span className="text-megapack-cyan font-bold" data-id="element-181">
              Funciona desde hoy. Para cualquier universidad argentina.
            </span>
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto" data-id="element-182">
            {bullets.map((b, i) => <div key={i} className="flex items-center gap-3" data-id="element-183">
                <span className="text-megapack-green text-xl" data-id="element-184">✅</span>
                <span className="font-bold text-[15px] sm:text-base" data-id="element-185">{b}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};